import CustomInput from "../../../../components/customInput";
import { debounceAsync } from "../../../../helper/helpers";
import React, { useCallback } from "react";

export const DebouncedDirectTextInput = ({ validateForm }) => {
  const debounceUpdate = useCallback(
    debounceAsync(() => validateForm(), 2000),
    []
  );
  return (
    <CustomInput
      type="textarea"
      name="commaSeparatedText"
      placeholder="Type comma separated values..."
      allowClear={true}
      onChange={debounceUpdate}
      autoSize={{ minRows: 4, maxRows: 4 }}
    />
  );
};
